import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=ffa873d0&"
import script from "./VersionHistory.vue?vue&type=script&lang=js&"
export * from "./VersionHistory.vue?vue&type=script&lang=js&"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=ffa873d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports